<template>
  <Modal
    id="modal_import_panier"
    @change="!$event && hide()"
    @before-open="onBeforeOpen"
  >
    <template #title>
      {{ $t("panier.importer") }}
    </template>
    <template #subtitle>
      {{ $t("panier.importer-panier-visiteur-dans-liste") }}
    </template>
    <template #content>
      <p class="text-regular">
        {{ $t("panier.recuperer-panier-en-liste-connecte-desc") }}
      </p>
    </template>
    <template #footer>
      <div
        v-if="ouvertureAutomatique"
        class="wide"
      >
        <ButtonCheckbox
          v-model="nePlusAfficher"
          name="ne_plus_afficher"
          :label="$t('action.ne-plus-afficher')"
          color="primary"
          size="sm"
        />
      </div>
      <ButtonClassic
        variant="ghost"
        :label="ouvertureAutomatique ? $t('action.ignorer') : $t('action.annuler')"
        color="secondary"
        :icon="nePlusAfficher ? 'left' : 'none'"
        @click="hide(!nePlusAfficher)"
      >
        <template #left-icon>
          <UilTimesCircle />
        </template>
      </ButtonClassic>
      <ButtonClassic
        variant="solid"
        class="right"
        :label="$t('action.continuer')"
        color="primary"
        icon="left"
        @click="confirm()"
      >
        <template #left-icon>
          <UilArrowRight />
        </template>
      </ButtonClassic>
    </template>
  </Modal>
</template>

<script>
import { ButtonCheckbox, ButtonClassic, Modal } from "@lde/core_lde_vue";
import { UilArrowRight, UilTimesCircle } from "@lde/vue-unicons";

import Api from "@/modules/axios";
import { setHideModalImportPanier } from "@/modules/utils";
/**
 * Modal qui s'affiche lorsqu'un visiteur (non connecté) ayant des articles dans son panier
 * se connecte. Elle lui propose de transformer son panier anonyme en liste.
 */
export default {
  name: "ModalImportPanier",
  components: {
    ButtonCheckbox,
    ButtonClassic,
    Modal,
    UilArrowRight,
    UilTimesCircle,
  },
  emits: ["hidden", "confirm"],
  data() {
    return {
      nePlusAfficher: false,
      ouvertureAutomatique: true,
    };
  },
  methods: {
    onBeforeOpen(event) {
      if (event && typeof event === "object") {
        if (event.params && typeof event.params === "object" && "ouvertureAutomatique" in event.params) {
          this.ouvertureAutomatique = !!event.params.ouvertureAutomatique;
          return;
        }
        if ("ouvertureAutomatique" in event) {
          this.ouvertureAutomatique = !!event.ouvertureAutomatique;
          return;
        }
      }
      this.ouvertureAutomatique = true;
    },
    hide(showAgain = true) {
      if (!showAgain) {
        setHideModalImportPanier(true);
      }
      this.$modal.hide("modal_import_panier");
      this.$emit("hidden");
    },
    confirm() {
      // On va envoyer un backend une requête pour valider la transformation du panier en liste.
      Api()
        .post("/liste/import_panier_visiteur/")
        .then((data) => {
          this.$toast.success({ title: this.$t("panier.panier-importe-liste-success") });
          // On force le rechargement de la page pour afficher la nouvelle liste.
          this.$emit("confirm");
          this.hide(false);

          // Dans le data, on a "id" et "libelle" de la nouvelle liste.
          if (data?.data?.id) {
            this.$router.push({ name: "listes_devis_listes_item", params: { id: data.data.id } });
          } else {
            this.$router.push({ name: "listes_devis_listes" });
          }
        })
        .catch(() => {
          this.$toast.error({ title: this.$t("panier.panier-importe-liste-error") });
        });
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/styles/components/modals/modal_import_panier.scss";
</style>
